const state = {
  user: null,
  verify: false,
  widgets: null,
  chosenWidget: null,
  chatHistory: [],
  totalMessagesCount: 0,
  subscription: null
};

const mutations = {
  setSubscription(state, value) {
    state.subscription = value;
  },
  setVerify(state, value) {
    state.verify = value;
  },
  setUser(state, user) {
    state.user = user;
    state.verify = user.verify;
  },
  setChosen(state, widget) {
    state.chosenWidget = widget;
  },
  updateChosen(state, updates) {
    state.chosenWidget = {...state.chosenWidget, ...updates}
  },
  setWidgets(state, widgets) {
    state.widgets = widgets;
  },
  setTotalMessagesCount(state, totalMessagesCount) {
    state.totalMessagesCount = totalMessagesCount;
  },
  updateWidgets(state, newWidget) {
    state.widgets = state.widgets.map((widget) => {
      if (widget.id == newWidget.id) {
        return newWidget;
      }
      return widget;
    });
  },
  deleteOneOfWidgets(state, widgetId) {
    state.widgets = state.widgets.filter((widget) => widget.id !== widgetId);
  },
  setChatHistory(state, chatHistory) {
    state.chatHistory = chatHistory;
  },
};

const actions = {
  setSubscription({ commit, dispatch }, data) {
    commit("setSubscription", data);
  },
  setUser({ commit, dispatch }, data) {
    commit("setUser", data);
  },
  setChosen({ commit, dispatch }, data) {
    commit("setChosen", data);
  },
  updateChosen({commit, dispatch}, data) {
    commit("updateChosen", data)
  },
  setWidgets({ commit, dispatch }, data) {
    commit("setWidgets", data);
  },
  setTotalMessagesCount({ commit, dispatch }, data) {
    commit("setTotalMessagesCount", data);
  },
  updateWidgets({ commit, dispatch }, data) {
    commit("updateWidgets", data);
  },
  deleteOneOfWidgets({ commit, dispatch }, data) {
    commit("deleteOneOfWidgets", data);
  },
  setChatHistory({ commit, dispatch }, data) {
    commit("setChatHistory", data);
  },
};

const getters = {
  getSubscription: (state) => {
    return state.subscription;
  },
  isVerify: (state) => {
    return state.verify;
  },
  getEmail: (state) => {
    return state.email;
  },
  getChosen: (state) => {
    return state.chosenWidget;
  },
  getWidgets: (state) => {
    return state.widgets;
  },
  getTotalMessagesCount: (state) => {
    return state.totalMessagesCount;
  },
  getChatHistory: (state) => {
    return state.chatHistory;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
